import React, { useEffect } from 'react';
import { Select } from 'antd';
import { useRecoilState } from 'recoil';
import { searchCmpBox } from '../../recoilatoms/searchCmp';
import { VOC_SEARCH_OPTIONS, SERVICE_SEARCH_OPTIONS, TAB_TYPE } from '../../constants';
import type { TabType } from '../../types';

interface SearchSelectBoxProps {
  activeTab: TabType;
}

/** SERVICE 탭 전용 검색 옵션 값 목록 */
const SERVICE_ONLY_OPTIONS = ['법인명', '사업자등록번호', '작성자명'];

/** VOC 탭 전용 검색 옵션 값 목록 */
const VOC_ONLY_OPTIONS = ['작성자', '조치담당자'];

const SearchSelectBox: React.FC<SearchSelectBoxProps> = ({ activeTab }) => {
  const [searchCmp, setSearchCmp] = useRecoilState<string>(searchCmpBox);

  useEffect(() => {
    const searchCmpStr = String(searchCmp);
    // SERVICE 탭 전용 옵션이 VOC 탭에서 선택된 경우 초기화
    if (activeTab !== TAB_TYPE.SERVICE && SERVICE_ONLY_OPTIONS.includes(searchCmpStr)) {
      setSearchCmp('제목');
    }
    // VOC 탭 전용 옵션이 SERVICE 탭에서 선택된 경우 초기화
    if (activeTab === TAB_TYPE.SERVICE && VOC_ONLY_OPTIONS.includes(searchCmpStr)) {
      setSearchCmp('제목');
    }
  }, [activeTab, searchCmp, setSearchCmp]);

  const handleChange = (selected: { value: string }) => {
    setSearchCmp(selected.value);
  };

  const options = activeTab === TAB_TYPE.SERVICE ? SERVICE_SEARCH_OPTIONS : VOC_SEARCH_OPTIONS;
  const searchCmpStr = String(searchCmp);

  return (
    <Select
      labelInValue
      value={{ value: searchCmpStr, label: searchCmpStr }}
      style={{ width: 130, marginRight: 10, height: 32 }}
      optionFilterProp="children"
      onChange={handleChange}
      options={[...options]}
    />
  );
};

export default SearchSelectBox;
